module.exports = __webpack_public_path__ + "img/open.4cbcf117.svg";